import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  InputBase,
  Box,
  Tooltip,
} from '@mui/material';
import { Add, Search, Close } from '@mui/icons-material';
import MainContentContainer from './../../MainContentContainer/MainContentContainer';
import QuickTapsTable from '../../QuickTapsTable/QuickTapsTable';

const QuickTapsPage = () => {
  const searchInputRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for Cmd+F (Mac) or Ctrl+F (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'f' && e.shiftKey) {
        e.preventDefault();
        if (!isSearchOpen) {
          handleToggleSearch();
        }
      }
      // Close search with Escape
      if (e.key === 'Escape' && isSearchOpen) {
        e.preventDefault();
        handleToggleSearch();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isSearchOpen]);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleToggleSearch = useCallback(() => {
    setIsSearchOpen((prev) => !prev);
    if (isSearchOpen) {
      setSearchText("");
    } else {
      setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
    }
  }, [isSearchOpen]);

  return (
    <MainContentContainer>
      <AppBar position="sticky">
        <Toolbar>
          {isSearchOpen ? (
            <Box display="flex" alignItems="center" flexGrow={1}>
              <InputBase
                inputRef={searchInputRef}
                value={searchText}
                onChange={handleSearchChange}
                sx={{
                  flexGrow: 1,
                  px: 2,
                  py: 1,
                  backgroundColor: "white",
                  borderRadius: 1,
                  '& input': {
                    color: 'text.primary',
                  }
                }}
                placeholder="Search quick taps..."
              />
              <IconButton color="inherit" onClick={handleToggleSearch}>
                <Close />
              </IconButton>
            </Box>
          ) : (
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Quick Taps
            </Typography>
          )}
          <Tooltip title="Search (⌘F)">
            <IconButton color="inherit" onClick={handleToggleSearch}>
              <Search />
            </IconButton>
          </Tooltip>
          <Button
            color="inherit"
            component={Link}
            to="/quick-taps/featured"
            sx={{ mr: 1 }}
          >
            Featured
          </Button>
          <Button
            color="inherit"
            component={Link}
            to="/quick-taps/add"
            startIcon={<Add />}
            sx={{
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)'
              }
            }}
          >
            Add Quick Tap
          </Button>
        </Toolbar>
      </AppBar>
      <QuickTapsTable searchText={searchText} />
    </MainContentContainer>
  );
};

export default QuickTapsPage;
